import {KTIcon, toAbsoluteUrl} from '../../../helpers'
import {HeaderNotificationsMenu, HeaderUserMenu, QuickLinks} from '../../../partials'
const AsideFooter = () => {
  const authData = JSON.parse(localStorage.getItem('kt-auth-react-v') || '{}');
  return (
    <div
      className='aside-footer d-flex flex-column align-items-center flex-column-auto'
      id='kt_aside_footer'
    >
      {/* begin::Quick links */}
      {/* <div className='d-flex align-items-center mb-2'>
        <div
          className='btn btn-icon btn-active-color-primary btn-color-gray-400 btn-active-light'
          data-kt-menu-trigger='click'
          data-kt-menu-overflow='true'
          data-kt-menu-placement='top-start'
          data-bs-toggle='tooltip'
          data-bs-placement='right'
          data-bs-dismiss='click'
          title='Quick links'
        >
          <KTIcon iconName='element-plus' className='fs-2 text-lg-1' />
        </div>
        <QuickLinks backgroundUrl='/media/misc/pattern-1.jpg' />
      </div> */}
      {/* end::Quick links */}

      {/* begin::Activities */}
      {/* <div className='d-flex align-items-center mb-3'>
        <div
          className='btn btn-icon btn-active-color-primary btn-color-gray-400 btn-active-light'
          data-kt-menu-trigger='click'
          data-kt-menu-overflow='true'
          data-kt-menu-placement='top-start'
          data-bs-toggle='tooltip'
          data-bs-placement='right'
          data-bs-dismiss='click'
          title='Activity Logs'
          id='kt_activities_toggle'
        >
          <KTIcon iconName='chart-simple' className='fs-2 text-lg-1' />
        </div>
      </div> */}
      {/* end::Activities */}

      {/* begin::Notifications */}
      {/* <div className='d-flex align-items-center mb-2'>
        <div
          className='btn btn-icon btn-active-color-primary btn-color-gray-400 btn-active-light'
          data-kt-menu-trigger='click'
          data-kt-menu-overflow='true'
          data-kt-menu-placement='top-start'
          data-bs-toggle='tooltip'
          data-bs-placement='right'
          data-bs-dismiss='click'
          title='Notifications'
        >
          <KTIcon iconName='element-11' className='fs-2 text-lg-1' />
        </div>
        <HeaderNotificationsMenu backgrounUrl='/media/misc/pattern-1.jpg' />
      </div> */}
      {/* end::Notifications */}

      {/* begin::User */}
      <div className='d-flex align-items-center mb-10' id='kt_header_user_menu_toggle'>
        {/* begin::Menu wrapper */}
        <div
          className='cursor-pointer symbol symbol-40px'
          data-kt-menu-trigger='click'
          data-kt-menu-overflow='false'
          data-kt-menu-placement='top-start'
          title='User profile'
        >
           {authData.user.picture ? (
              <img
                src={authData.user.picture}
                alt='Profile Pic'
                className='img-fluid rounded-circle shadow-sm'
              />
            ) : (
              <div className='symbol symbol-circle bg-white text-black d-flex align-items-center justify-content-center' style={{ height: '50px', width: '50px' }}>
                <span className='fs-3 fw-bold'>
                {
                  authData.user?.is_superadmin ===1?(
                    authData.user.full_name ? authData.user.full_name[0].toUpperCase() : ''
                  ):( authData.user.first_name ? authData.user.first_name[0].toUpperCase() : '')
                }
                </span>
              </div>
            )}
        </div>
        {/* end::Menu wrapper */}
        <HeaderUserMenu />
      </div>
      {/* end::User */}
    </div>
  )
}

export {AsideFooter}
